<template>
  <div class="Subpage">
    <Bigmenu
      :NavStatus="Bignav"
      :Way="2"
      :ShowBackBtn="true"
      v-on:cellback="OpenStatus"
      style="z-index: 2"
    ></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container
      v-if="!Bignav"
      :Type="false"
      :ImgUrl="'b01.png'"
      :Container="Container"
      style="z-index: -6"
    ></Container>
  </div>
</template>

<script>
import Bigmenu from "@/components/Bigmenu.vue";
import Back from "@/components/Back.vue";
import Container from "@/components/Container.vue";
export default {
  name: "About",
  data() {
    return {
      Bignav: false,
      Container: {
        title: "HyperArc超弧刀",
        videosrc: "T03.mp4",

        list: [
          {
            body:
              "此為針對顱內之無痛式立體定位放射治療技術。無須釘頭架，減緩病患的恐懼及不舒適感。全自動一鍵式治療程序治療作業可同時治療多顆腫瘤，大幅縮短治療時間。此技術具備自我安全檢查程序，保障病患安全。"
          }
        ]
      }
    };
  },
  components: {
    Back,
    Container,
    Bigmenu
  },
  methods: {
    OpenStatus(v) {
      this.Bignav = v.status;
    }
  }
};
</script>
<style lang="scss" scoped>
.Subpage {
  height: 100%;
  width: 100%;
}
.frame {
  position: absolute;
  background-image: url("../../assets/frame.png");
  background-position: center;
  height: 1080px;
  width: 1920px;
}
</style>
